import { render, staticRenderFns } from "./CoozzyCopyIcon.vue?vue&type=template&id=1a8bc03c&scoped=true"
import script from "./CoozzyCopyIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCopyIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCopyIcon.vue?vue&type=style&index=0&id=1a8bc03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bc03c",
  null
  
)

export default component.exports